import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "edpCapitalize",
})
export class EdpCapitalizePipe implements PipeTransform {
    transform(value: unknown, ...args: unknown[]): unknown {
        if (!value) {
            return value;
        }
        let string = String(value);
        string = string.toLocaleLowerCase();
        return `${string.charAt(0).toUpperCase()}${string.substring(1).toLowerCase()}`;
    }
}
